<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="500px">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">处理服务</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="form">
                <el-form-item prop="server_title">
                    <el-input v-model="ruleForm.server_title" placeholder="请输入服务标题">
                    </el-input>
                </el-form-item>
                <el-form-item prop="server_num">
                    <el-input v-model="ruleForm.server_num" placeholder="请输入服务人数">
                        <template slot="append">人</template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="server_content">
                    <el-input v-model="ruleForm.server_content" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入服务内容" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">稍后再填</el-button>
                <el-button :loading="loading" class="operate" @click="submitForm('ruleForm')">
                    立即处理
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {changeServerApply} from "@/api/organiz";
import  rules from '@/utils/rules'
export default {
    name: "disposeServiceDialog",
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        sid: { //详情ID
            type: Number,
        },
    },
    data() {
        return {
            loading: false,
            ruleForm: {
                server_title: '',
                server_content: '',
                server_num: '',
            },
            rules: {
                server_title: [
                    {required: true, message: '请输入服务标题', trigger: 'blur'},
                ],
                server_num: [
                    {required: true, message: '请输入服务人数', trigger: 'blur'},
                    rules.num
                ],
                server_content: [
                    {required: true, message: '请输入服务内容', trigger: 'blur'},
                    {min: 5, message: '意见建议至少为 5 个字符', trigger: 'blur'}
                ]
            },
        }
    },
    created() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.applyServer();
                }
            });
        },
        async applyServer() {
            this.loading = true
            let _data = await changeServerApply(this.sid,this.ruleForm.server_title,this.ruleForm.server_content,
            this.ruleForm.server_num)
            this.loading = false
            if (_data.status === 200) {
                this.clearContent()
                this.$message.success(_data.msg)
                this.$emit('watchState', true)
            }
        },
        cancel() {
            this.clearContent()
            this.$emit('watchState', false)
        },
        clearContent() {
            this.$refs.ruleForm.resetFields()
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            padding: 40px 80px;
            height: 605px;

            .title {
                font-size: 24px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .content {
                margin-top: 38px;
                overflow-y: scroll;

                &::-webkit-scrollbar {
                    display: none
                }
            }

            .time {
                font-size: 16px;
                color: #0a2240;
                margin-top: 16px;
            }
        }

        .dialog-operate {
            margin-top: 20px;

            .operate {
                width: 200px;
                height: 40px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;

                &.black {
                    background: #0a2240 none;
                }
            }

            .operate + .operate {
                margin-left: 80px;
            }
        }

        .dialog-footer {
            height: 40px;
            background-color: #e7eff9;
            padding: 0 20px;
            border-radius: 0 0 10px 10px;

            .content {
                font-size: 16px;
                color: #8b9fbe;
            }
        }
    }
}
</style>
